import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// UTILITY
import { checkIsAbsoluteUrl } from '@/utility/routes';
import { analyticsClickedToApp, externalLink, getExternalUrlParams } from '@/utility/analytics';
import { updateUrl } from '@/utility/common';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import { Container } from './styles';

const BannerPromo = ({ data, link, analyticsProps, analyticsLocation }) => {
  const downMd = useMediaQuery(({ breakpoints }) => breakpoints.down('md'));
  const downSm = useMediaQuery(({ breakpoints }) => breakpoints.down('sm'));
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));
  const { unique_id } = useSelector(({ auth }) => ({
    unique_id: auth.unique_id,
  }));

  function getImg() {
    const defImg = data.lg || data.md || data.sm || data.xs;
    let img = defImg;

    if (!defImg) return null;

    if (downMd) img = data.md || defImg;

    if (downSm) img = data.sm || data.md || defImg;

    if (downXs) img = data.xs || data.sm || data.md || defImg;

    return <img className="banner-promo__img" src={img} alt="Promo banner" />;
  }

  function handleLinkClicked() {
    const properties = {
      ...analyticsProps,
      from_page_path: window.location.pathname,
      from_search_params: window.location.search,
      location: analyticsLocation,
    };

    analyticsClickedToApp(properties);
  }

  function handleExternalLinkClicked(href) {
    externalLink({ href, location: analyticsLocation });

    handleLinkClicked();
  }

  function getLink() {
    if (!link) return null;

    const externalUrlParams = getExternalUrlParams({ unique_id });
    const href = updateUrl(link, externalUrlParams);

    const isExternalLink = checkIsAbsoluteUrl(href);

    if (isExternalLink) {
      return (
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        <a
          className="banner-promo__link"
          href={href}
          onClick={() => handleExternalLinkClicked(href)}
          title="Banner link"
          target="_blank"
          aria-label="Banner link"
          rel="noreferrer"
        />
      );
    }

    return (
      <RouterLink
        className="banner-promo__link"
        to={href}
        location={analyticsLocation}
        onClick={handleLinkClicked}
      />
    );
  }

  const linkComp = getLink();
  const imgComp = getImg();

  if (!imgComp) return null;

  return (
    <Container className="banner-promo">
      {linkComp}
      {imgComp}
    </Container>
  );
};

BannerPromo.defaultProps = {
  link: '',
  analyticsProps: {},
};

BannerPromo.propTypes = {
  data: PropTypes.object.isRequired,
  link: PropTypes.string,
  analyticsLocation: PropTypes.string.isRequired,
  analyticsProps: PropTypes.object,
};

export default React.memo(BannerPromo);
